import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AppStatsPage} from "../app-stats/app-stats";
import {AppStatsFoodPage} from "../app-stats-food/app-stats-food";
import {UserStateProvider} from "../../providers/user-state/user-state";

/**
 * Generated class for the AppStatsIntroPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-stats-intro',
  templateUrl: 'app-stats-intro.html',
})
export class AppStatsIntroPage {

  statsActivity: any = AppStatsPage;
  foodActivity: any = AppStatsFoodPage;

  programData: any = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, private userState: UserStateProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppStatsIntroPage');
    console.log(this.userState.user);
    this.programData = this.userState.user.program;
  }

  goBack() {
    this.navCtrl.parent.select(0);
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-stats-intro/app-stats-intro.ts